import React from 'react'

import type { IconProps } from './types'

const Tag: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.26922 14.0358C9.0774 14.2273 8.8397 14.323 8.55614 14.323C8.27257 14.323 8.03506 14.2273 7.8436 14.0358L1.97694 8.16916C1.88036 8.07258 1.80451 7.96141 1.74939 7.83566C1.69425 7.70992 1.66669 7.57579 1.66669 7.43328V2.66661C1.66669 2.39397 1.76519 2.15914 1.9622 1.96214C2.1592 1.76513 2.39403 1.66663 2.66667 1.66663H7.43334C7.57094 1.66663 7.70274 1.69348 7.82875 1.74719C7.95478 1.80089 8.06399 1.87318 8.1564 1.96406L14.0231 7.84099C14.2188 8.03672 14.3177 8.27581 14.3199 8.55828C14.322 8.84074 14.2273 9.0777 14.0359 9.26916L9.26922 14.0358ZM4.33259 5.16659C4.56385 5.16659 4.76068 5.08565 4.92307 4.92376C5.08546 4.76187 5.16665 4.56529 5.16665 4.33403C5.16665 4.10276 5.08571 3.90593 4.92382 3.74354C4.76193 3.58115 4.56535 3.49996 4.33409 3.49996C4.10282 3.49996 3.90599 3.5809 3.7436 3.74279C3.58121 3.90468 3.50002 4.10126 3.50002 4.33253C3.50002 4.56379 3.58096 4.76062 3.74285 4.92301C3.90474 5.0854 4.10132 5.16659 4.33259 5.16659Z"
        fill={'currentColor'}
      />
    </svg>
  )
}

export default Tag
